export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-month-view-1.0.0',
    name: 'JDSDatepickerMonthView'
  },
  hierarchy: {
    container: ['jds_datepicker_view_button']
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      height: '{d_1}',
      width: '{d_2}',
      'align-items': '{d_3}',
      overflow: 'scroll'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'months',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_view_button: {
        name: {
          type: 'string',
          name: 'months.name'
        },
        selected: {
          type: 'boolean',
          name: 'months.selected'
        },
        disabled: {
          type: 'boolean',
          name: 'months.disabled'
        }
      }
    },
    events: {
      jds_datepicker_view_button: {
        onSelect: 'onSelect'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'list'
          }
        }
      }
    }
  }
};
